<template>

    <div id="live-ticker" class="container">

        <div class="row mb-4">

            <div class="col-1">Image</div>
            <div class="col-2">Name</div>
            <div class="col-1 text-right">Last Price</div>
            <div class="col-1 text-right">Amount</div>
            <div class="col-1 text-right">Volume</div>
            <div class="col-3">7d History</div>
            <div class="col-3">30d History</div>
        </div>
        <div class="row py-2 border-bottom" v-for="res in resources">
            <div class="col-1 align-self-center"><img class="building-product-image"  :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+res.image" alt=""></div>
            <div class="col-2 align-self-center">{{ res.name }}</div>
            <div class="col-1 align-self-center text-right">{{ parseFloat(res.minprice).toFixed(3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</div>
            <div class="col-1 align-self-center text-right">{{ parseFloat(res.amount).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</div>
            <div class="col-1 align-self-center text-right">{{ (res.avgprice * res.amount).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</div>
            <div class="col-3 text-right"><SparkChart :resource=res.data.db_letter mode="7d"></SparkChart></div>
            <div class="col-3 text-right"><SparkChart :resource=res.data.db_letter mode="30d"></SparkChart></div>
        </div>
    </div>
</template>

<script>
    import SparkChart from '@/components/SparkChart.vue'

    export default {
        name: 'Pricelist',
        components: {
            SparkChart
        },
        computed: {
            resources() {
                return this.$store.state.resources;
            }
        }
    };
</script>

<style scoped lang="scss">

    img {
        max-width: 40px;
    }

    .container {
        max-width: 1400px;
    }
</style>
